import { render, staticRenderFns } from "./LaundryStatistics.vue?vue&type=template&id=afb29950&scoped=true"
import script from "./LaundryStatistics.vue?vue&type=script&lang=js"
export * from "./LaundryStatistics.vue?vue&type=script&lang=js"
import style0 from "./LaundryStatistics.vue?vue&type=style&index=0&id=afb29950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb29950",
  null
  
)

export default component.exports